"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subAppLoader = void 0;
const utils_1 = require("./utils");
const buildEntrypoint_1 = require("./buildEntrypoint");
/**
 * Builds the subapp config object and injects it
 * into window.globals so it can be shared with frame
 *
 * The rendering of the subapp in the DOM is delegated
 * to the DynamicLoader
 */
const subAppLoader = async ({ id, API, APITracker, app: App, translationsConfig, trackerConfig, mobileConnectorConfig, reducers = {}, libraries = [], }) => {
    const XHRTracker = APITracker ?? API;
    const entrypoint = (0, buildEntrypoint_1.buildEntrypoint)({ App, XHRTracker, API, translationsConfig, trackerConfig, mobileConnectorConfig, libraries });
    const config = {
        verticalId: id,
        entrypoint,
        reducers: reducers,
        wrapupConfig: {},
    };
    // TODO: this is the same as leaveVerticalConfigAvailable from DynamicLoadManualStatic
    (0, utils_1.leaveVerticalConfigAvailable)(id, config);
};
exports.subAppLoader = subAppLoader;
//# sourceMappingURL=index.js.map